import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box, useMediaQuery, useTheme } from '@mui/material';
import { MdMenu } from 'react-icons/md';
import ParameterScreen from '../screens/ParameterScreen';

const Header: React.FC = () => {
  const [isParameterOpen, setIsParameterOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const handleSettings = () => {
    setIsParameterOpen(true);
  };

  const handleCloseParameter = () => {
    setIsParameterOpen(false);
  };

  // On desktop, the sidebar handles logo + settings
  if (isDesktop) {
    return null;
  }

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: 'transparent',
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            minHeight: '70px',
            px: '15px',
          }}
        >
          <Box
            component="a"
            href="https://visamonde.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src="/logoblanc.png"
              alt="Logo"
              sx={{
                width: 150,
                height: 50,
                objectFit: 'contain',
                cursor: 'pointer',
              }}
            />
          </Box>
          <IconButton onClick={handleSettings} sx={{ color: 'white' }}>
            <MdMenu size={36} />
          </IconButton>
        </Toolbar>
      </AppBar>

      <ParameterScreen open={isParameterOpen} onClose={handleCloseParameter} />
    </>
  );
};

export default Header;
